export default __webpack_public_path__ + "static/media/Ocorrências (Real Size).689e1b20.svg";